<template>
  <a-menu-item key="editProjectUser" @click="showEditProjectUserModal">
    <EditOutlined />&nbsp;編輯人員&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="650px" title="專案人員編輯" :maskClosable="isMaskClosable" 
        :closable="isMaskClosable" :cancelButtonProps="cancelButtonProps" :confirm-loading="isSavingProjectUser" 
        okText="儲存" cancelText="關閉" @cancel="cancelEditProjectUser" @ok="saveEditProjectUser">
      <a-divider />
      <a-form ref="editProjectUserForm" :model="formState" name="basic" :rules="formRules" :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 13 }" :disabled="isSavingProjectUser">
        <a-form-item ref="personalNo" label="證件編號" name="personalNo">
          <a-input v-model:value="formState.displayPersonalNo" disabled style="width: 85%"/>
        </a-form-item>
        <a-form-item ref="name" label="名稱" name="name">
          <a-input v-model:value="formState.name" style="width: 85%"/>
        </a-form-item>
        <a-form-item ref="healthNo" label="健康編號" name="healthNo">
          <a-input v-model:value="formState.healthNo" style="width: 85%"/>
        </a-form-item>
        <a-form-item ref="sex" label="性別" name="sex">
            <a-radio-group v-model:value="formState.sex" style="width: 85%">
                <a-radio value="Male">男性</a-radio>
                <a-radio value="Female">女性</a-radio>
            </a-radio-group>
        </a-form-item>
        <a-form-item ref="birthday" label="生日" name="birthday">
            <a-space direction="vertical">
                <a-date-picker v-model:value="formState.birthday" @change="updateMingoBirthday" />
                <a-tag :bordered="false" color="geekblue">{{ mingoBirthday }}</a-tag>
            </a-space>
        </a-form-item>
        <a-form-item ref="jobNo" label="工/學號" name="jobNo">
          <a-input v-model:value="formState.jobNo" style="width: 85%"/>
        </a-form-item>
        <a-form-item ref="workStartDate" label="到職日" name="workStartDate">
            <a-date-picker v-model:value="formState.workStartDate" />
        </a-form-item>
        <a-form-item ref="compName" label="公司名稱" name="compName">
          <a-input v-model:value="formState.compName" style="width: 85%"/>
        </a-form-item>
        <a-form-item ref="unitName" label="單位名稱" name="unitName">
          <a-input v-model:value="formState.unitName" style="width: 85%"/>
        </a-form-item>
      </a-form>
  </a-modal>
</template>
<script setup>
import { EditOutlined } from "@ant-design/icons-vue";
import { ref, reactive, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import common from "@/common";
import config from "@/config";

const props = defineProps(['projectUrl', 'projectQuestUser']);

const editProjectUserForm = ref();
const isOpen = ref(false);
const formState = reactive({});
const mingoBirthday = ref("");
const isMaskClosable = ref(false);
const isSavingProjectUser = ref(false);
const cancelButtonProps = ref({
  disabled: isSavingProjectUser
});

const emit = defineEmits(['cancel', 'submit-success']);

const formRules = {
  name: [{
    required: true,
    message: '請輸入姓名',
    trigger: ['change', 'blur']
  }], 
  sex: [{
    required: true,
    message: '請選擇性別',
    trigger: ['change', 'blur']
  }], 
  birthday: [{
    required: true,
    message: '請設定人員生日',
    trigger: ['change', 'blur']
  }]
};

const updateMingoBirthday = () => {
    if (formState.birthday == null) {
        mingoBirthday.value = "";
        return ;
    }
    const mingoYear = parseInt(formState.birthday.format('YYYY')) - 1911;
    const month = formState.birthday.format('MM');
    const day = formState.birthday.format('DD');
    mingoBirthday.value = "民國 " + mingoYear + " 年 " + month + " 月 " + day + " 日";
}

const initFormStateByProjectUser = (projectUser) => {
    formState.name = projectUser.name;
    formState.personalNo = projectUser.personalNo;
    formState.displayPersonalNo = common.getDisplayPersonalNo(projectUser.personalNo);
    formState.healthNo = projectUser.healthNo;
    formState.sex = projectUser.sex;
    formState.birthday = common.isEmpty(projectUser.westBirthday) ? 
        null : dayjs(projectUser.westBirthday, 'YYYY/MM/DD');
    formState.jobNo = projectUser.jobNo;
    formState.workStartDate = common.isEmpty(projectUser.westWorkStartDate) ? 
        null : dayjs(projectUser.westWorkStartDate, 'YYYY/MM/DD');
    formState.compName = projectUser.compName;
    formState.unitName = projectUser.unitName;
    updateMingoBirthday();
}

const showEditProjectUserModal = () => {
  common.getRequest(config.mgmtProjectUserEntities + "/" + props.projectUrl + "/" + props.projectQuestUser.personalNo, 
    (response) => {
        if (editProjectUserForm.value != null) {
            editProjectUserForm.value.resetFields();
        }
        initFormStateByProjectUser(response.data);
        setTimeout(() => isOpen.value = true, 100);
    });
}

const cancelEditProjectUser = () => {
    isOpen.value = false;
    emit('cancel');
}

const saveEditProjectUser = () => {
    editProjectUserForm.value.validate()
    .then(() => {
        isSavingProjectUser.value = true;
        common.postRequest(config.mgmtSaveProjectUserEntity + "/" + props.projectUrl, formState, 
            () => {
                isSavingProjectUser.value = false;
                message.success("人員資料儲存成功");
                isOpen.value = false;
                emit('submit-success', formState, props.projectQuestUser);
            }, () => {
                isSavingProjectUser.value = false;
            });
    })
    .catch(() => { });
}
</script>